module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wittinsburg-ab05fbe337479ade0914545badd96efa.svg";